module.exports = __webpack_public_path__ + "static/media/sysco.c2361dda.jpg";